// extracted by mini-css-extract-plugin
export var card = "RelatedArticles-module--card--121f2";
export var content = "RelatedArticles-module--content--9e5ef";
export var root = "RelatedArticles-module--root--1ad51";
export var slider = "RelatedArticles-module--slider--93048";
export var title = "RelatedArticles-module--title--13db1";
export var titleWrapper = "RelatedArticles-module--title-wrapper--5c32e";